import { render, staticRenderFns } from "./DdSubHeader.vue?vue&type=template&id=a6c7742e&scoped=true&"
import script from "./DdSubHeader.vue?vue&type=script&lang=js&"
export * from "./DdSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./DdSubHeader.vue?vue&type=style&index=0&id=a6c7742e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c7742e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
